import { Box } from "@mui/material";
import { Theme } from "@analyticsMD/quil";
import { ErrorBoundary } from "react-error-boundary";

import MalnutritionAPIContextProvider from "../../contexts/MalnutritionAPIContext/Provider";
import MalnutritionCardContent from "./malnutrition-card-content";
import ErrorPage from "../error-page";

import type { FC, ReactNode } from "react";
import type MalnutritionListEntry from "../../types/MalnutritionListEntry";

interface MalnutritionDrawerProps {
  patient: MalnutritionListEntry | null;
  closeButtonCmpt: ReactNode;
}

// The malnutrition card opened from a list row. It loads the patient's card by
// the row's emr ids, exactly as the embedded card does, so the two agree.
const MalnutritionDrawer: FC<MalnutritionDrawerProps> = ({
  patient,
  closeButtonCmpt,
}) => {
  if (!patient) return null;

  return (
    <Theme>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <MalnutritionAPIContextProvider
            key={patient.emr_patient_id}
            emrPatientID={patient.emr_patient_id}
            emrHospitalID={patient.emr_hospital_id}
          >
            <ErrorBoundary
              fallbackRender={() => (
                <ErrorPage closeButtonCmpt={closeButtonCmpt} includeHeader />
              )}
            >
              <MalnutritionCardContent closeButtonCmpt={closeButtonCmpt} />
            </ErrorBoundary>
          </MalnutritionAPIContextProvider>
        </Box>
      </Box>
    </Theme>
  );
};

export default MalnutritionDrawer;
